export default Math.PI * 2;



/** WEBPACK FOOTER **
 ** /Users/songseunggeun/pawsong/gdx-ai.js/src/math/PI2.ts
 **/